export default __webpack_public_path__ + "static/media/login.6172879f.png";